import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 16,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 0H3.5V6.5H0.5V0Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4 10C4 11.1046 3.10457 12 2 12C0.895431 12 0 11.1046 0 10C0 8.89543 0.895431 8 2 8C3.10457 8 4 8.89543 4 10Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.5 0H0.5V6.5H3.5V0ZM2 12C3.10457 12 4 11.1046 4 10C4 8.89543 3.10457 8 2 8C0.895431 8 0 8.89543 0 10C0 11.1046 0.895431 12 2 12Z",
			fill: "white"
		})
	]
});
export default SvgExclamationMark;
